import React from 'react';

import {ImageUploaderForDocuments} from 'app/general/widgets/Uploaders/ImageUploaderForDocuments';
import {SetNextStepButton} from 'app/procedures/components/ProcedureEditPage/SetNextStepButton';
import {StepEmbedOptions} from 'app/procedures/components/ProcedureEditPage/StepEmbedOptions';
import {StepEditFieldWrapper} from 'app/procedures/components/step-form-fields/StepEditFieldWrapper';
import {
  StepFormFieldsTitle,
  StepVideosTitle,
} from 'app/procedures/components/structures';
import {SetStepLaneButton} from 'app/steps/components/edit/SetStepLaneButton';

import {EditableProcedureStepFiles} from './EditableProcedureStepFiles';

import {EditableStepEmbedsGallery} from '../EditableStepEmbedsGallery';
import {EditableStepImagesGallery} from '../EditableStepImagesGallery';

import type {ApplyStepShaperFuncType} from 'app/steps/document-shaper';
import type {ProcedureStepType} from 'sweet-types';

type Props = {
  step: ProcedureStepType;
  steps: Array<ProcedureStepType>;
  stepLaneId?: string | null;
  applyStepShaper: ApplyStepShaperFuncType;
  onBusy: (id: number, isBusy: boolean) => void;
};
export const EditableProcedureFooter = ({
  step,
  steps,
  stepLaneId,
  applyStepShaper,
  onBusy,
}: Props): JSX.Element => (
  <div className="flex-grow-1">
    <div className="step-image-edit clearfix images">
      <div className="step-images">
        {('images' in step && step.images.length > 0) ||
        ('embeds' in step && step.embeds.length > 0) ? (
          <StepVideosTitle className="mt-3" />
        ) : null}
        <EditableStepImagesGallery
          images={'images' in step ? step.images : []}
          onEditImage={(image_ref, index) =>
            applyStepShaper((stepShaper) =>
              stepShaper.images
                .updateByIndex(index, {
                  image_ref,
                })
                .procedure()
            )
          }
          onRemoveImage={(image, index) =>
            applyStepShaper((stepShaper) =>
              stepShaper.images.removeByIndex(index).procedure()
            )
          }
        />
        <EditableStepEmbedsGallery
          embeds={'embeds' in step ? step.embeds : []}
          onRemove={(embed, index) =>
            applyStepShaper((stepShaper) =>
              stepShaper.embeds.removeByIndex(index).procedure()
            )
          }
        />
      </div>
      <div className="step-files">
        <EditableProcedureStepFiles
          files={step.type === 'content' ? step.files : []}
          onRemove={(index) =>
            applyStepShaper((stepShaper) =>
              stepShaper.files.removeByIndex(index).procedure()
            )
          }
        />
      </div>
    </div>
    <ImageUploaderForDocuments
      onAddImage={(image) =>
        applyStepShaper((stepShaper) =>
          stepShaper.images.add(image).procedure()
        )
      }
    />

    {'fields' in step && step.fields != null && step.fields.length > 0 ? (
      <div className="mb-4">
        <StepFormFieldsTitle className="mt-3" />
        {step.fields.map((field, index) =>
          step.fields != null ? (
            <StepEditFieldWrapper
              key={field.id}
              field={field}
              fieldIndex={index}
              numFields={step.fields.length}
              onRemoveField={(field) =>
                applyStepShaper((stepShaper) =>
                  stepShaper.fields.remove(field.id).procedure()
                )
              }
              onChangeField={(field: any) =>
                applyStepShaper((stepShaper) =>
                  stepShaper.fields.update(field.id, field).procedure()
                )
              }
              onReorderField={(source, target) =>
                applyStepShaper((stepShaper) =>
                  stepShaper.fields.move(source, target).procedure()
                )
              }
            />
          ) : null
        )}
      </div>
    ) : null}
    <div className="d-flex justify-content-end mb-2">
      {!step.type || step.type === 'content' || step.type === 'ending' ? (
        <>
          <div className="mr-1">
            <SetStepLaneButton
              applyStepShaper={applyStepShaper}
              stepLaneId={stepLaneId}
            />
          </div>
          {step.type !== 'ending' ? (
            <SetNextStepButton
              applyStepShaper={applyStepShaper}
              stepId={step.id}
              steps={steps}
              next={step.next}
            />
          ) : null}
        </>
      ) : null}
    </div>
    {step.type !== 'ending' ? (
      <div className="mb-2 clearfix d-flex align-items-end flex-wrap">
        <StepEmbedOptions
          onAddField={(field) =>
            applyStepShaper((stepShaper) =>
              stepShaper.fields.add(field).procedure()
            )
          }
          onAddFile={(file) =>
            applyStepShaper((stepShaper) =>
              stepShaper.files.add(file).procedure()
            )
          }
          onAddIframe={(iframeURL) =>
            applyStepShaper((stepShaper) =>
              stepShaper.embeds.add({embed_html: iframeURL}).procedure()
            )
          }
          onAddVideo={(image) =>
            applyStepShaper((stepShaper) =>
              stepShaper.images.add(image).procedure()
            )
          }
          onBusy={onBusy}
        />
      </div>
    ) : null}
  </div>
);
